import { Component } from '@angular/core';
import { AppErrorComponent } from '../app.error.component';
import { Store } from '@ngrx/store';

@Component({
  selector: 'polaris-no-content',
  standalone: false,
  template: `
    <div>
      <h3>{{ messageBasedOnState$ | async }}</h3>
    </div>
  `,
})
export class NoContentComponent extends AppErrorComponent {
  constructor(protected store: Store) {
    super(store);
  }
}
